// extracted by mini-css-extract-plugin
export default {"wrapper":"bv-z","viewport":"cv-z","container":"dv-z","slide":"ev-z"};